import _ from "lodash";
import {
  getUpdateData,
  persistAddress,
  persistBankData,
  persistCustomer,
  persistCaseInsurance,
  persistPerson,
} from "./persisterService";
import { CaseInsurance } from "../../types/CaseInsurance";
import { UseForm } from "../../types/UseForm";
import { ProductUnion } from "../../types/ProductUnion";

export const persistAbstractCaseSubEntities = async (updateData: UseForm["values"], originalBaseData: ProductUnion) => {
  if (_.isObject(updateData.customer)) {
    const customerUpdateData = getUpdateData(updateData.customer, originalBaseData, "customer");
    await persistCustomer(originalBaseData.customer.id, customerUpdateData);
  }

  if (_.isObject(updateData.caseInsurance)) {
    const caseInsuranceUpdateData = getUpdateData(updateData.caseInsurance, originalBaseData, "caseInsurance", true);

    const caseInsurance: Partial<CaseInsurance> = updateData.caseInsurance;
    caseInsuranceUpdateData.insurer = caseInsurance.insurer?.id
      ? "/insurers/" + caseInsurance.insurer.id
      : originalBaseData.caseInsurance.insurer?.["@id"];

    await persistCaseInsurance(originalBaseData.caseInsurance.id, caseInsuranceUpdateData);
  }

  if (_.has(updateData, "caseInsurance.policyHolder") && _.isObject(updateData.caseInsurance.policyHolder)) {
    const policyHolderUpdateData = getUpdateData(
      updateData.caseInsurance.policyHolder,
      originalBaseData,
      "caseInsurance.policyHolder"
    );
    await persistPerson(originalBaseData.caseInsurance.policyHolder.id, policyHolderUpdateData);
  }

  if (_.isObject(updateData.petitioner)) {
    const petitionerUpdateData = getUpdateData(updateData.petitioner, originalBaseData, "petitioner");
    await persistPerson(originalBaseData.petitioner.id, petitionerUpdateData);
  }

  if (_.has(updateData, "petitioner.residenceAddress") && _.isObject(updateData.petitioner.residenceAddress)) {
    const petitionerAddressUpdateData = getUpdateData(
      updateData.petitioner.residenceAddress,
      originalBaseData,
      "petitioner.residenceAddress"
    );
    await persistAddress(originalBaseData.petitioner.residenceAddress.id, petitionerAddressUpdateData);
  }

  if (_.isObject(updateData.client)) {
    let clientUpdateData;
    //special handling for familyLawPersister while this isn't the prettyest everything
    //else inside the familyLawPersister is covered with this persistAbstractCaseSubEntities
    if (originalBaseData.productClassName === "familyLawCase") {
      clientUpdateData = getUpdateData(updateData.client, originalBaseData, "client");
    } else {
      clientUpdateData = getUpdateData(updateData.client, originalBaseData, "petitioner");
    }
    await persistPerson(originalBaseData.client.id, clientUpdateData);
  }

  if (_.has(updateData, "client.residenceAddress") && _.isObject(updateData.client.residenceAddress)) {
    const clientAddressUpdateData = getUpdateData(
      updateData.client.residenceAddress,
      originalBaseData,
      "client.residenceAddress"
    );
    await persistAddress(originalBaseData.client.residenceAddress.id, clientAddressUpdateData);
  }

  if (_.has(updateData, "client.bankData") && _.isObject(updateData.client.bankData)) {
    const bankData = getUpdateData(updateData.client.bankData, originalBaseData, "client.bankData");
    await persistBankData(originalBaseData.client.bankData.id, bankData);
  }
};
